import { render, staticRenderFns } from "./PlanManage.vue?vue&type=template&id=90249b10&scoped=true"
import script from "./PlanManage.vue?vue&type=script&lang=js"
export * from "./PlanManage.vue?vue&type=script&lang=js"
import style0 from "./PlanManage.vue?vue&type=style&index=0&id=90249b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90249b10",
  null
  
)

export default component.exports